import { generators, GamepadMacroCodec } from '@playcastdotio/Messaging';
import { ipcSend } from '../../../../api/messaging/protocols/ipc';
import type { PlaycastGamepadXInput } from '@playcastdotio/CoreTypes';
import { MacroPlaybackClock } from './MacroPlaybackClock';


export class MacroGamepadEmitter {
  private readonly active = new Set<0 | 1 | 2 | 3>();
  public release(slot?: 0 | 1 | 2 | 3): void {
    for (const gamepadId of slot === undefined ? [...this.active] : [slot]) {
      if (!this.active.has(gamepadId)) continue;
      ipcSend(generators.gamepad.setXInput('host', { gamepadId, playerCoordinates: {
      origin: 'bottomLeft', dimensions: { x: 0, y: 0 }, display: { x: 0, y: 0 },
      }, xInput: GamepadMacroCodec.neutral() }));
      this.active.delete(gamepadId);
    }
  }
  public async sendGamepadTap(button: string, hold: number, signal?: AbortSignal, continueState = false): Promise<void> {
    if (signal?.aborted) throw new Error('Macro cancelled');
    const downX = GamepadMacroCodec.control(button);
    const gamepadId = GamepadMacroCodec.deviceId(button);

    const base: Omit<PlaycastGamepadXInput, 'xInput'> = {
      gamepadId,
      playerCoordinates: {
        origin: 'bottomLeft',
        dimensions: { x: 0, y: 0 },
        display: { x: 0, y: 0 },
      },
    };

    let completed = false;
    try {
      this.active.add(gamepadId);
      ipcSend(generators.gamepad.setXInput('host', { ...base, xInput: downX }));
      await MacroPlaybackClock.wait(hold, signal);
      completed = true;
    }
    finally { if (!completed || !continueState) this.release(gamepadId); }
    if (!GamepadMacroCodec.isState(button)) await MacroPlaybackClock.wait(20, signal);
  }
}
